
import { AlertService } from '../../Services/alert.service';
import { GroupFormComponent } from '../group-form/group-form.component';
import { CalendarService } from '../../Services/calendar.service';
import { CourseService } from '../../Services/course.service';
import { GroupService } from '../../Services/group.service';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { IMyDpOptions, IMyMarkedDate, IMyDayLabels } from 'mydatepicker';
import Swal from 'sweetalert2';
import { AuthService } from '../../Services/auth.service';

@Component({
  selector: 'app-calendar-creator-form',
  template: require('./calendar-creator-form.component.html'),
  styles: [require('./calendar-creator-form.component.css')]
})

export class CalendarCreatorFormComponent implements OnInit {
  groups: any[] = [];
  courses: any[] = [];

  selectedSort:string = "dtAsc";
  selectedSearchSort:string ="rnDesc"
  currentSelectedCourse: any = {};

  selectedDate: any;
  selectedGroupId: any;
  selectedCourseId: any;
  calendar: any[] = [];
  currentCalendarEntry: any = {}

  courseUrl: string = "";
  courseName: string = "";
  // racefietsType = 1;
  selectedCat: number =1;

  nameNrSearchString:string = "";
  selected_courses:any[] = [];
  searched_courses: any[] = [];

  selectedFilter:string="NoFilter";
  filterBegin: number=0;
  filterEnd: number=0;

  CurrentSelectedCourseID = -1;  
  CurrentSelectedCourseKm:number = 0;
  CurrentSelectedCourseHm:number = 0;
  CurrentSelectedCourseTitle:string = "";

  PreviewInformation:string="";
  categories: any[] = [];

  myDatePickerOptions: IMyDpOptions = {
    todayBtnTxt: 'Vandaag',
    dateFormat: 'dd/mm/yyyy',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    markCurrentDay: true,
    height: '34px',
    width: '210px',
    alignSelectorRight: false,
    openSelectorTopOfInput: false,
    indicateInvalidDate: true,
    monthSelector: true,
    yearSelector: true,
    minYear: 1920,
    maxYear: 2200,
    componentDisabled: false,
    editableDateField:false,
    showClearDateBtn: true,
    showDecreaseDateBtn: false,
    showIncreaseDateBtn: false,
    showSelectorArrow: true,
    showInputField: true,
    openSelectorOnInputClick: false,
    disableHeaderButtons: true,
    showWeekNumbers: false,
    markDates: [],
    satHighlight: false,
    highlightDates: [],
    markWeekends: <IMyMarkedDate>{},
    monthLabels: {
        1: 'Januari',
        2: 'Februari',
        3: 'Maart',
        4: 'April',
        5: 'Mei',
        6: 'Juni',
        7: 'July',
        8: 'Augustus',
        9: 'September',
        10: 'Oktober',
        11: 'November',
        12: 'December'
    },
    dayLabels: <IMyDayLabels>{
      su: 'zo', mo: 'ma', tu: 'di', we: 'wo', th: 'do', fr: 'vr', sa: 'za'
    },
    allowDeselectDate: true,
    disableWeekdays: [],
    allowSelectionOnlyInCurrentMonth: true
    
};

  constructor(
    private groupService: GroupService,
    private courseService: CourseService,
    private calendarService: CalendarService,
    private alertService: AlertService,
    private sanitizer: DomSanitizer,
    private auth: AuthService
  ) { }

  ngOnInit() {
    
    this.groupService.getGroupNames(true).subscribe(x => {
      this.groups = x;
    });

    this.loadCourses()
    this.loadGroups()
  }

  loadCourses(){
    this.courseService.getCoursesbyType(this.selectedCat).subscribe(x => {
      this.courses = x;
      this.searched_courses =  this.courses;
    })
  }

  loadGroups(){
    this.courseService.getCourseCategories().subscribe( x =>{
      this.categories = x;
    });
  }

  getCalendarEntry(){
    var dateSpecified = false;
    if (this.selectedDate != null){
      if (this.selectedDate.hasOwnProperty('date')){        
        dateSpecified = true;
      }
    }

    var calendarEntry = {
      groupId: this.selectedGroupId,
      // date:   d,
      courseId: this.currentSelectedCourse.id,
      course: this.currentSelectedCourse
    }
    
    if (dateSpecified) {
      (calendarEntry as any).date =  new Date(Date.UTC(this.selectedDate.date.year, this.selectedDate.date.month - 1, this.selectedDate.date.day))
    }
    return calendarEntry
  }

  clearCurrentCalendarEntry(){
    this.currentCalendarEntry = {}
    this.currentSelectedCourse = {}
    this.selectedCourseId = -1
  }

  addToCalendar() {
    var calendarEntry = this.getCalendarEntry();
    this.calendar.push(calendarEntry)
    this.submit();
  }

  submit() {
    this.calendarService.update(this.calendar).subscribe(x => {
      this.calendar = x;
      this.alertService.success("Kalender bewaard.");
      this.clearCurrentCalendarEntry();
      this.SelectionChanged();
    });

  }

  removeItem(i: number) {
    Swal.fire({
        title: 'Ben je zeker?',
        text: "Ben je zeker dat je dit wil verwijderen?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Jep',
        cancelButtonText: 'Nope'
      }).then((result) => {
        if (result.value) {
          this.calendar.splice(i, 1);
          this.submit();
        }
      });
  }

  groupSelected() {
    this.calendarService.getCalendar(this.selectedGroupId).subscribe((x: any) => {
      this.calendar = x;
    });
    this.currentCalendarEntry = this.getCalendarEntry()       
  }

  showModal() {
    if (this.selectedCourseId) {
      var index = this.courses.findIndex((m: any) => m.id == this.selectedCourseId);
      var course = this.courses[index]

      this.courseUrl = "https://www.gpsies.com/mapOnly.do?fileId=" + this.getGpsIdFromUrl(course.url)
      this.courseName = course.name
    }

  }

  private getGpsIdFromUrl(url: string) {
    // url = "http://www.gpsies.com/map.do?fileId=uzeundqqribhepiu"
    var check = "fileId"
    var pos = url.indexOf(check);
    return url.substr(pos + check.length + 1)
  }

  checkClick(s:string){
    switch (s) {
      case "dt":
        if (this.selectedSort == "dtAsc"){
          this.selectedSort = "dtDesc"
        }
        else {
          this.selectedSort = "dtAsc"
        }
        break;
    
      default:
        break;
    }
    this.SelectionChanged()
  }


  SelectionChanged(){
    switch (this.selectedSort) {
      case "dtAsc":
        this.calendar.sort( (a,b) => (a.date > b.date)? 1: ((b.date > a.date)? -1:0)  )
        break;
      case "dtDesc":
        this.calendar.sort( (a,b) => (b.date > a.date)? 1: ((a.date > b.date)? -1:0)  )
        break;
      default:
        break;
    }
  }

  showExtraInfo(){
    var extraInfo = this.currentSelectedCourse.extraInfo.replace(/\n/g,'<br>');
    var innerhtml = `
      <div class="text-left mt-5">
        ${extraInfo}
      </div>
    `
    
    Swal.fire({
      title: 'Extra informatie',
      html: innerhtml,
      type: 'info',
      showCloseButton: false,
      showCancelButton: false,
      focusConfirm: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ok',
    })
  }

  CourseSelectionChanged(){
    this.currentSelectedCourse = this.courses.find( c => c.id == this.selectedCourseId);
  }

  checkIfCurrentSelectedCourseHasExtraInfo(){
    if (!this.checkIfObjectIsEmpty(this.currentSelectedCourse)){
      if (this.currentSelectedCourse.extraInfo != null) {
        return true
      }else{
        return false
      }
    }else{
      return false
    }
  }

  clearNameNrSearch(){
    this.nameNrSearchString = '';
    this.searchNameNr();
  }

  clearFilterBeginSearch(){
    this.filterBegin = 0;
    this.searchFilter()
  }

  clearFilterEndSearch(){
    this.filterEnd = 0;
    this.searchFilter()
  }

  searchNameNr(){
    if (this.nameNrSearchString.length > 0){
      var course_names: any[] = [];
      var nameNrToSearch = this.nameNrSearchString.toLowerCase()
      this.courses.forEach(c => {
        if (c.name.toLowerCase().indexOf(nameNrToSearch) > -1 ){
          course_names.push(c)
        }
        if (c.courseNr == nameNrToSearch){
          course_names.push(c)
        }        
      });
      this.searched_courses = course_names;
    }else{
      this.searched_courses =  this.courses;
    }
  }

  searchFilter(){
    var course_names: any[] = [];
    this.courses.forEach( c =>{

      switch (this.selectedFilter) {
        case "Distance":
          if (c.distance >= this.filterBegin && c.distance <=this.filterEnd) {
            course_names.push(c)
          }    
          break;
        case "Altitude":
            if (c.altitudeMeters >= this.filterBegin && c.altitudeMeters <=this.filterEnd) {
              course_names.push(c)
            }    
            break;
        case "Gr":
          if (c.gr >= this.filterBegin && c.gr <=this.filterEnd) {
            course_names.push(c)
          }    
          break;
        case "NoFilter":
          course_names = this.courses
          break;
        default:
          break;
      }
      

    })
    this.searched_courses = course_names;
  }

  SetCurrentCourseID(id:number){
    this.CurrentSelectedCourseID = id;

    this.courseService.getCourse(this.CurrentSelectedCourseID).subscribe( (res:any)=>{
      this.CurrentSelectedCourseKm = res.distance;
      this.CurrentSelectedCourseHm = res.altitudeMeters;
      this.CurrentSelectedCourseTitle = res.name;
      this.currentSelectedCourse = res;
      
      this.PreviewInformation = this.CurrentSelectedCourseTitle+" / "+this.CurrentSelectedCourseKm+"Km - "+this.CurrentSelectedCourseHm+"Hm"
      
    })

  }

  private checkIfObjectIsEmpty(s:any){
    return Object.keys(s).length == 0;
  }

  SelectRow(id:number){
    this.SetCurrentCourseID(id)   
  }


  searchResultSortClick(s:string){
    switch (s) {
      case "rn":
        if (this.selectedSearchSort == "rnAsc"){
          this.selectedSearchSort = "rnDesc"
        }
        else {
          this.selectedSearchSort = "rnAsc"
        }
        break;
      case "distance":
        if (this.selectedSearchSort == "dtAsc"){
          this.selectedSearchSort = "dtDesc"
        }
        else {
          this.selectedSearchSort = "dtAsc"
        }
        break;
      case "gr":
        if (this.selectedSearchSort == "grAsc"){
          this.selectedSearchSort = "grDesc"
        }
        else {
          this.selectedSearchSort = "grAsc"
        }
        break;
      case "hm":
        if (this.selectedSearchSort == "hmAsc"){
          this.selectedSearchSort = "hmDesc"
        }
        else {
          this.selectedSearchSort = "hmAsc"
        }
        break;
      default:
        break;
    }
    this.SelectionSearchChanged()
  }

  SelectionSearchChanged(){    
    switch (this.selectedSearchSort){
      case "rnAsc": {
        this.searched_courses.sort((a,b) => (a.courseNr > b.courseNr) ? 1 : ((b.courseNr > a.courseNr) ? -1 : 0))
        break;
      }
      case "rnDesc": {
        this.searched_courses.sort((a,b) => (b.courseNr > a.courseNr) ? 1 : ((a.courseNr > b.courseNr) ? -1 : 0));
        break;
      }
      case "dtAsc": {
        this.searched_courses.sort((a,b) => (a.distance > b.distance) ? 1 : ((b.distance > a.distance) ? -1 : 0))
        break;
      }
      case "dtDesc": {
        this.searched_courses.sort((a,b) => (b.distance > a.distance) ? 1 : ((a.distance > b.distance) ? -1 : 0));
        break;
      }
      case "hmAsc": {
        this.searched_courses.sort((a,b) => (a.altitudeMeters > b.altitudeMeters) ? 1 : ((b.altitudeMeters > a.altitudeMeters) ? -1 : 0))
        break;
      }
      case "hmDesc": {
        this.searched_courses.sort((a,b) => (b.altitudeMeters > a.altitudeMeters) ? 1 : ((a.altitudeMeters > b.altitudeMeters) ? -1 : 0));
        break;
      }
      case "grAsc": {
        this.searched_courses.sort((a,b) => (a.gr > b.gr) ? 1 : ((b.gr > a.gr) ? -1 : 0))
        break;
      }
      case "grDesc": {
        this.searched_courses.sort((a,b) => (b.gr > a.gr) ? 1 : ((a.gr > b.gr) ? -1 : 0));
        break;
      }
    }
  }

  selectCourse(){
    this.currentCalendarEntry = this.getCalendarEntry()   
  }


  searchGroupNameById(id: string){
    var g = this.groups.find(g => g.id == this.selectedGroupId)
    return g.name
  }

  onChangeDate(value: any){
    this.currentCalendarEntry = this.getCalendarEntry()   
  }

  isCurrentCalendarItemValid() {
    if (!this.checkIfObjectIsEmpty(this.currentCalendarEntry)){
      if ( (this.currentCalendarEntry.hasOwnProperty('groupId')) && ( this.currentCalendarEntry.groupId > -1) ){
        if (this.currentCalendarEntry.hasOwnProperty('date')){
          if ( (this.currentCalendarEntry.hasOwnProperty('course')) && (this.currentCalendarEntry.course.courseNr > 0) && (this.currentCalendarEntry.course.name.length > 0)){
            return true;
          }
        }
      }
    }
    else {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/calendar-creator-form/calendar-creator-form.component.ts